<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        v-bind="attrs"
        v-on="on"
        class="mb-4"
        @click="openMenuPrinter"
      >
        {{ $t("lang.admin.printer_form.label_print") }}
      </v-btn>
    </template>
    <v-card class="pb-1">
      <v-card-title class="mb-n4">
        {{ $t("lang.admin.printer_form.print_form") }}
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="height: 200px">
        <v-card-text class="select-tag" style="height: 230px" v-if="loading">
          <PuSkeleton :duration="1.5" height="25px" width="180px"></PuSkeleton>
        </v-card-text>

        <v-select
          :items="printers"
          item-text="description"
          item-value="id"
          v-model="selectedPrinter"
          v-if="printers && printers.length > 0"
          prefix="Printer :   "
          outlined
        ></v-select>

        <v-row
          class="print-qty w-100 mt-n4 py-0 h-auto"
          aria-disabled="true"
          v-if="printers.length > 0"
        >
          <v-radio-group v-model="qtyGroup" class="m-0 p-0" hide-details>
            <v-col>
              <v-radio
                value="all"
                :label="$t('lang.inbound.dashboard.label_all')"
                color="#9ac31c"
                class="mb-0"
                :disabled="!selectedPrinter"
              ></v-radio>
            </v-col>
            <v-col class="d-flex flex-row align-center">
              <v-radio
                value="qty"
                :label="$t('lang.inbound.dashboard.label_from')"
                color="#9ac31c"
                class="mb-0"
                :disabled="!selectedPrinter"
              >
              </v-radio>
              <v-text-field
                type="number"
                :rules="rules"
                v-model="qtyFrom"
                outlined
                dense
                class="px-0 pl-2 mb-n4"
                :disabled="!selectedPrinter || qtyGroup !== 'qty'"
              ></v-text-field>
              <span
                class="mx-2"
                :style="{
                  color:
                    !selectedPrinter || qtyGroup !== 'qty' ? '#aaa' : '#000'
                }"
                >to</span
              >
              <v-text-field
                type="number"
                :rules="rules"
                v-model="qtyTo"
                outlined
                dense
                class="p-0 mb-n4"
                :disabled="!selectedPrinter || qtyGroup !== 'qty'"
              ></v-text-field>
            </v-col>
          </v-radio-group>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between mt-n3">
        <v-btn color="#717C7D" text @click="close">Close</v-btn>
        <v-btn color="primary" @click="printOrder" :disabled="checkIsDisabled">
          {{ $t("lang.inbound.dashboard.label_print") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {
      loading: false,
      qtyGroup: "all",
      printers: [],
      dialog: false,
      selectedPrinter: null,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1,
      qtyFrom: 1,
      qtyTo: 500,
      rules: [
        v =>
          v >= this.item.from_label ||
          this.$t("lang.inbound.dashboard.error_min", {
            num: this.item.from_label
          }),
        v =>
          v <= this.item.total_quantity ||
          this.$t("lang.inbound.dashboard.error_max", {
            num: this.item.total_quantity
          })
      ]
    };
  },
  computed: {
    checkIsDisabled() {
      if (!this.selectedPrinter) return true;
      return false;
    }
  },
  methods: {
    async openMenuPrinter() {
      this.loading = true;
      this.printers = await this.$api.printer.printer_list();
      this.qtyFrom = this.item.from_label;
      this.qtyTo = this.item.total_quantity;
      this.loading = false;
      this.dialog = true;
    },
    print() {
      this.$emit("print", this.printer);
      this.dialog = false;
    },
    async printOrder() {
      const params = {
        printorder_id: this.item.id,
        print_id: this.selectedPrinter,
        from: this.qtyFrom,
        to: this.qtyTo
      };
      await this.$api.printer.printer_print(params);
      // this.$emit("refresh-page");
      this.close();
    },
    close() {
      this.$emit("refresh-page");
      this.dialog = false;
      this.selectedPrinter = null;
    }
  }
};
</script>

<style scoped>
.select-tag > .v-text-field__prefix {
  margin-right: 1rem !important;
  background: #aaa !important;
}
</style>
